import { NotaFiscalProvider } from "../../ModalDetalheNotaFiscalContext";
import ListarNotasFiscais from "./Listagem";
import { ModalDetalheHistoricoRecebimentoProvider } from "../../../../Estoque/components/MIEntradaProdutos/ModalDetalheHistoricoRecebimentoContext";

export default function ListarTodas() {
  return (
    <ModalDetalheHistoricoRecebimentoProvider>
      <NotaFiscalProvider>
        <ListarNotasFiscais />
      </NotaFiscalProvider>
    </ModalDetalheHistoricoRecebimentoProvider>
  )
}
